// this line disabled type checking for this pipe to repvent issues with the "new Intl" namespace
// @ts-nocheck

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toCountryName'
})
export class ToCountryNamePipe implements PipeTransform {

  transform(countryCode: string, args?: any): any {
    try{
        let getCountryNames = new Intl["DisplayNames"](['en'], {type: 'region'});
        let countryName = getCountryNames.of(countryCode);
        return countryName;
    }catch{
        return countryCode;
    }
   
  }

}
